'use client'

import { useEffect } from 'react'
import { useReportWebVitals } from 'next/web-vitals'
import { reportWebVitals } from '@/lib/performance-monitor'

export function WebVitals() {
  useReportWebVitals((metric) => {
    // Map Next.js metric to our format
    const rating =
      metric.rating === 'good' ? 'good' :
      metric.rating === 'needs-improvement' ? 'needs-improvement' : 'poor'

    reportWebVitals({
      name: metric.name,
      value: metric.value,
      rating,
      delta: metric.delta,
    })
  })

  // Removed initPerformanceMonitoring() - it's optional and can cause TBT issues
  // If needed, manually call it only in development:
  // useEffect(() => {
  //   if (process.env.NODE_ENV === 'development') {
  //     import('@/lib/performance-monitor').then(({ initPerformanceMonitoring }) => {
  //       initPerformanceMonitoring()
  //     })
  //   }
  // }, [])

  return null
}
